// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-common-Loading-Loading-module__container-lQ2wpY","preActive":"src-app-components-common-Loading-Loading-module__preActive-gS6IrZ","active":"src-app-components-common-Loading-Loading-module__active-kFDKu5","scale-animation":"src-app-components-common-Loading-Loading-module__scale-animation-FQgTU5","scaleAnimation":"src-app-components-common-Loading-Loading-module__scale-animation-FQgTU5","remarks":"src-app-components-common-Loading-Loading-module__remarks-iJ0PvH","info":"src-app-components-common-Loading-Loading-module__info-CnP5RJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-common-Loading-Loading-module__container-lQ2wpY\",\"preActive\":\"src-app-components-common-Loading-Loading-module__preActive-gS6IrZ\",\"active\":\"src-app-components-common-Loading-Loading-module__active-kFDKu5\",\"scale-animation\":\"src-app-components-common-Loading-Loading-module__scale-animation-FQgTU5\",\"scaleAnimation\":\"src-app-components-common-Loading-Loading-module__scale-animation-FQgTU5\",\"remarks\":\"src-app-components-common-Loading-Loading-module__remarks-iJ0PvH\",\"info\":\"src-app-components-common-Loading-Loading-module__info-CnP5RJ\"}";
        // 1789362522800
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  